import { Components, Theme } from '@mui/material/styles'

export const surfacesCustomizations: Components<Theme> = {
  MuiAccordion: {
    styleOverrides: {
      root: () => ({
        padding: 4,
        overflow: 'clip',
        border: 'none',
      }),
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          padding: 0,
          transition: 'all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)',
          borderRadius: '4px',
          border: `none`,
          boxShadow: 'none',
          ...theme.applyStyles('light', {
            boxShadow:
              '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
            '&:hover': {
              boxShadow:
                '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)',
            },
          }),
          ...theme.applyStyles('dark', {}),
          variants: [
            {
              props: {
                variant: 'outlined',
              },
              style: {
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: 'none',
                ...theme.applyStyles('dark', {}),
              },
            },
          ],
        }
      },
    },
  },
}
